// Storage types
export const nextcloud = 'urn:openproject-org:api:v3:storages:Nextcloud';
export const oneDrive = 'urn:openproject-org:api:v3:storages:OneDrive';

// Storage authorization state
export const storageConnected = 'urn:openproject-org:api:v3:storages:authorization:Connected';
export const storageNotConnected = 'urn:openproject-org:api:v3:storages:authorization:NotConnected';
export const storageFailedAuthorization = 'urn:openproject-org:api:v3:storages:authorization:FailedAuthorization';
export const storageAuthorizationError = 'urn:openproject-org:api:v3:storages:authorization:Error';

// File link view permission flags
export const fileLinkViewAllowed = 'urn:openproject-org:api:v3:file-links:permission:ViewAllowed';
export const fileLinkViewNotAllowed = 'urn:openproject-org:api:v3:file-links:permission:ViewNotAllowed';
export const fileLinkStatusNotFound = 'urn:openproject-org:api:v3:file-links:NotFound';
export const fileLinkStatusError = 'urn:openproject-org:api:v3:file-links:Error';
